import confirmAndDeleteAnalysisView from 'analysis-tool/confirmAndDeleteAnalysisView';
import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import {checkCanModifyStep} from 'analysis-tool/EditStepHelpers';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import {PipelineGraphQL, PipelineViewGraphQL} from 'pipelines/PipelineTypes';
import {resolveLineageStep} from 'pipelines/PipelineViewUtils';

export default function getDeleteViewAction(
  analysis: PipelineGraphQL,
  view: PipelineViewGraphQL,
  analysisClientStateId: string
): OverflowDataViewAction | null {
  if (isAnalysisReadOnly(analysis)) {
    return null;
  }

  const firstNode = view.lineage[0];
  const {canEdit, message} = checkCanModifyStep(analysis, firstNode.step.id, 'view', 'delete');

  return {
    icon: 'delete',
    onClick: () => {
      const firstStep = resolveLineageStep(analysis.steps, firstNode);
      return confirmAndDeleteAnalysisView({
        analysis,
        stepId: firstNode.step.id,
        stepType: firstStep.stepType,
        analysisClientStateId,
        typeName: 'view',
      });
    },
    label: `Delete view`,
    isDisabled: !canEdit,
    helpText: !canEdit ? message : undefined,
  };
}
